/**
 * Global Scroll Animations for Thekla Ioakeim Theme
 * Uses IntersectionObserver for performant reveal animations.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Check if animations are disabled via CSS variable on the body
  if (document.body.classList.contains('ti-animations-disabled') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // Don't initialize observer if disabled
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px', // Trigger slightly before the element enters the viewport
    threshold: 0.05
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const elementsToAnimate = document.querySelectorAll('.ti-animate');
  elementsToAnimate.forEach(el => observer.observe(el));
});
